





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
enum UibotInvoiceState {
	/**
	 * 未采集
	 */
	未采集 = 1,
	/**
	 * 等待中
	 */
	等待中 = 2,
	/**
	 * 采集中
	 */
	采集中 = 3,
	/**
	 * 采集成功
	 */
	采集成功 = 4,
	/**
	 * 采集失败
	 */
	采集失败 = 5,
	/**
	 * 无税种可取
	 */
	无税种可取 = 6,
}


@Component({
	...mapGetters(["accountBook"]),
	components: {},
})
export default class ImportTax extends Vue {
	@Prop({ type: Object })
	bookData?: AccountBookList.AccountBook;

    status: string = ""
    statusEnum = UibotInvoiceState;
    result:any = ""
	async created() {
		this.getStatus();
	}

	async getStatus() {
        if(this.bookData){
            const res = await Vue.axios.get(
                `uibot/tax/info/get?accountBookId=${this.bookData.id}`
            );
            this.status = UibotInvoiceState[res.data.state];
            this.result = res.data;
            if(+res.data.state === 4){
                console.log("采集")
                this.$emit("find", true);
            }
        }
	}
    async saveInvoice() {
        if(this.bookData){
            const res = await Vue.axios.post(
                `uibot/tax/info/save?accountBookId=${this.bookData.id}`
            );
            this.getStatus();
        }
	}

	close() {
		this.$emit("close", true);
	}
}
